import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["enabled", "enable", "disable"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import compose from 'recompose/compose';
import withStateHandlers from 'recompose/withStateHandlers';
import mapProps from 'recompose/mapProps';
import PropTypes from 'prop-types';
var withEnabledState = function withEnabledState() {
  var initEnabledValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return compose(withStateHandlers({
    enabled: initEnabledValue
  }, {
    enable: function enable() {
      return function () {
        return {
          enabled: true
        };
      };
    },
    disable: function disable() {
      return function () {
        return {
          enabled: false
        };
      };
    }
  }), mapProps(function (_ref) {
    var enabled = _ref.enabled,
      enable = _ref.enable,
      disable = _ref.disable,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread(_objectSpread({}, restProps), {}, {
      enableHandler: {
        enabled: enabled,
        enable: enable,
        disable: disable
      }
    });
  }));
};
export default withEnabledState;
export var propTypes = {
  enableHandler: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    enable: PropTypes.func.isRequired,
    disable: PropTypes.func.isRequired
  }).isRequired
};